import Home from './views/Home';
import Services from './views/Services';
import Blog from './views/Blog';
import Commercials from './views/Commercials';
import Post from './views/Post';
import Work from './views/Work';
import About from './views/About';
import Contact from './views/Contact';
import Error from './views/404';

export default [{
  path: '/',
  component: Home,
}, {
  path: '/services',
  component: Services,
}, {
  path: '/commercials',
  component: Commercials,
}, {
  path: '/blog',
  component: Blog,
}, {
  path: '/blog/:slug',
  component: Post,
}, {
  path: '/work/:slug',
  component: Work,
}, {
  path: '/about',
  component: About,
}, {
  path: '/contact',
  component: Contact,
}, {
  path: '/404',
  component: Error,
}];



// WEBPACK FOOTER //
// ./src/routes.js